import { AutoLogout } from "@/App/components";
import { ExperienceContext } from "@/App/context";
import React, { ReactNode, useContext, useEffect } from "react";

interface Props {
  children: ReactNode;
  pageTitle: string;
  label: string;
  showIconLogo: boolean;
}

export const SingleComponentLayout: React.FC<Props> = (props: Props) => {
  const { children, pageTitle } = props;
  const { experience } = useContext(ExperienceContext);

  const documentPageTitle = () => {
    if (experience) {
      return pageTitle;
    } else {
      return `${site.companyName} - ${pageTitle}`;
    }
  };

  useEffect(() => {
    const body = document.body;
    body.classList.remove("authnz-root");
    document.title = documentPageTitle();
  }, []);

  return (
    <>
      <AutoLogout />
      {children}
    </>
  );
};
